import {
    IN_CURRENCY_ACTION,
    OUT_CURRENCY_ACTION,
    NOT_ACTIVE_IN_CURRENCY_ACTION,
    NOT_ACTIVE_OUT_CURRENCY_ACTION,
    AMOUNT_ACTION,
    IN_CURRENCY_SHOW_ACTION,
    OUT_CURRENCY_SHOW_ACTION,
    CLOSE_MODAL_ACTION,
    IN_CURRENCY_COIN,
    OUT_CURRENCY_COIN,
    SEARCH_MODAL_IN_ACTION,
    SEARCH_MODAL_OUT_ACTION,
    PAYWAY_ACTION,
    FAIL_PROVIDERS,
    NEXT_SCREEN,
    MODAL_ERROR_ACTION,
    PROVIDER_ACTION,
    COUNTRY_SHOW,
    MIN_MAX_HALF_ACTION,
    LIMITS_ARRAY_ACTION,
    LOADING_ACTION,
    RATE_PROVIDER_ACTION,
    CARD_DATA,
    CARD_COUNTRY_CODE,
    ONE_TIME_CARD,
    ADD_CARD,
    SEARCH_MODAL_COUNTRY_ACTION,
    NEED_VERIFICATION,
    SEARCH_MODAL_PAYWAY_ACTION,
    MOBILE_PHONE,
    MODAL_SERVER,
    ACCOUNT_NUMBER_ACTION,
    EMAIL_ACTION,
    COUNTED_FEES,
    CHECKED_ALMOST_ALL,
    ORDER_CREATED_ACTION,
    CREATED_ORDER_ERROR,
    EXPIRATED_RATE,
    POST_MESSAGE_ERROR
} from '../type'

export function inCurrencyAction(inCurrency, outDestination, walletName, minMaxLimits) {
    return {
        type: IN_CURRENCY_ACTION,
        inCurrency,
        outDestination, 
        walletName,
        minMaxLimits
    }
}

export function notActiveInCurrencyAction(inCurrency, outDestination, walletName) {
    return {
        type: NOT_ACTIVE_IN_CURRENCY_ACTION,
        inCurrency,
        outDestination, 
        walletName
    }
}

export function outCurrencyAction(outCurrency, minMaxLimits) {
    return {
        type: OUT_CURRENCY_ACTION,
        outCurrency,
        minMaxLimits
    }
}

export function notActiveOutCurrencyAction(outCurrency) {
    return {
        type: NOT_ACTIVE_OUT_CURRENCY_ACTION,
        outCurrency
    }
}

export function amountAction(amount, equivalent = null, timerId = null, providersArray = [], amountValid = false, amountHaveValid = false, loading = false, side = null, maxLimit = false) {
    return {
        type: AMOUNT_ACTION,
        amount,
        equivalent,
        timerId,
        providersArray,
        amountValid,
        amountHaveValid,
        loading,
        side,
        maxLimit
    }
}

export function inCurrencyShowAction() {
    return {
        type: IN_CURRENCY_SHOW_ACTION,
    }
}

export function outCurrencyShowAction(outPaywayShow) {
    return {
        type: OUT_CURRENCY_SHOW_ACTION,
        outPaywayShow
    }
}


export function closeModalAction() {
    return {
        type: CLOSE_MODAL_ACTION
    }
}

export function inCurrencyCoinAction(inCurrencyActive, inCurrencyNotActive) {
    return {
        type: IN_CURRENCY_COIN,
        inCurrencyActive,
        inCurrencyNotActive
    }
}

export function outCurrencyCoinAction(outCurrencyActive, outCurrencyNotActive) {
    return {
        type: OUT_CURRENCY_COIN,
        outCurrencyActive,
        outCurrencyNotActive
    }
}

export function searchInputModalInAction(searchValue) {
    return {
        type: SEARCH_MODAL_IN_ACTION,
        searchValue,
    }
}

export function searchInputModalOutAction(searchValue) {
    return {
        type: SEARCH_MODAL_OUT_ACTION,
        searchValue,
    }
}

export function paywayMethodAction(payway, minMaxLimits) {
    return {
        type: PAYWAY_ACTION,
        payway,
        minMaxLimits
    }
}

export function providersStatusAction(failProviders, rateProvider = null) {
    return {
        type: FAIL_PROVIDERS,
        failProviders,
        rateProvider
    }
}

export function providerAction(provider, rateProvider) {
    return {
        type: PROVIDER_ACTION,
        provider,
        rateProvider
    }
}

export function nextAction(screen) {
    return {
        type: NEXT_SCREEN,
        screen
    }
}

export function modalErrorAction(modalError, textError=null) {
    return {
        type: MODAL_ERROR_ACTION,
        modalError,
        textError
    }
}

export function countryShowAction(countryShow) {
    return {
        type: COUNTRY_SHOW,
        countryShow
    }
}

export function minMaxHalfAction(minMaxHalf, minMaxLimits) {
    return {
        type: MIN_MAX_HALF_ACTION,
        minMaxHalf,
        minMaxLimits
    }
}

export function limitsArrayAction(minMaxLimits, limitsTimerId) {
    return {
        type: LIMITS_ARRAY_ACTION,
        minMaxLimits,
        limitsTimerId
    }
}

export function loadingAction(loading) {
    return {
        type: LOADING_ACTION,
        loading
    }
}

export function rateProviderAction(rateProvider, minMaxLimits) {
    return {
        type: RATE_PROVIDER_ACTION,
        rateProvider,
        minMaxLimits
    }
}

export function cardNumberAction(cardData) {
    return {
        type: CARD_DATA,
        cardData
    }
}

export function cardCountrySelector(cardCountryCode) {
    return {
        type: CARD_COUNTRY_CODE,
        cardCountryCode
    }
}

export function oneTimeCardAction(oneTimeCard) {
    return {
        type: ONE_TIME_CARD,
        oneTimeCard
    }
}

export function addCardAction (cards) {
    return {
        type: ADD_CARD,
        cards
    }
}

export function searchInputModalCountryAction (searchValueCountry) {
    return {
        type: SEARCH_MODAL_COUNTRY_ACTION,
        searchValueCountry
    }
}

export function searchPaywayAction (searchValuePayway) {
    return {
        type: SEARCH_MODAL_PAYWAY_ACTION,
        searchValuePayway
    }
}

export function needVerificationAction (needVerification) {
    return {
        type: NEED_VERIFICATION,
        needVerification
    }
}

export function mobilePhoneAction (mobilePhone) {
    return {
        type: MOBILE_PHONE,
        mobilePhone
    }
}

export function modalServerAction (modalServer, textError=null) {
    return {
        type: MODAL_SERVER,
        modalServer,
        textError
    }
}

export function emailAction (email) {
    return {
        type: EMAIL_ACTION,
        email
    }
}

export function accountNumberAction (accountNumber){
    return {
        type: ACCOUNT_NUMBER_ACTION,
        accountNumber
    }
}

export function allFundsAction (countedFees, selectedFee, useAllFunds, loadAmount) {
    return {
        type: COUNTED_FEES,
        countedFees,
        selectedFee,
        useAllFunds,
        loadAmount
    }
}

export function checkedAlmostAllAction (checkedAlmostAll, originalData={}){
    return {
        type: CHECKED_ALMOST_ALL,
        checkedAlmostAll,
        originalData
    }
}

export function orderCreatedAction () {
    return {
        type: ORDER_CREATED_ACTION,
    }
}

export function createdOrderErrorAction(createdOrderError) {
    return {
        type: CREATED_ORDER_ERROR,
        createdOrderError
    }
}

export function expiratedRateAction(expiratedRate) {
    return {
        type: EXPIRATED_RATE,
        expiratedRate
    }
}

export function postMessageErrorAction (postMessageError) {
    return {
        type: POST_MESSAGE_ERROR,
        postMessageError
    }
}